import React from 'react'

const ListingFlightsPage = () => {
  return (
    <div>ListingFlightsPage</div>
  )
}

export default ListingFlightsPage